import { useCallback, useEffect } from 'react';
import useAutoplay from 'src/hooks/useAutoplay';
import usePlayback from 'src/hooks/usePlayback';
import usePlayerData from 'src/hooks/usePlayerData';
import usePlayerError from 'src/hooks/usePlayerError';
import usePlayerParams from 'src/hooks/usePlayerParams';
import { EVENT_TYPES } from 'src/interfaces/enums';
import ApplicationService from 'src/services/ApplicationService';
import { AUTOPLAY_DELAY_SECONDS } from './constants';

function useConfigEvents() {
  const { autoplay } = usePlayerParams();
  const { ready } = usePlayback();
  const {
    playerData: { drm: isDRM },
  } = usePlayerData();

  const { handleAutoplay } = useAutoplay();
  const { handleCatchError } = usePlayerError();

  useEffect(() => {
    ApplicationService.player?.addEventListener(EVENT_TYPES.ENDED, handleAutoplay);

    return () => ApplicationService.player?.removeEventListener(EVENT_TYPES.ENDED, handleAutoplay);
  }, [ready, handleAutoplay]);

  const createConfigListeners = useCallback(() => {
    const player = ApplicationService.player;
    if (!player) return;

    player.addFirstEventListener(EVENT_TYPES.READY, () => {
      autoplay && setTimeout(() => player.autoPlay(), AUTOPLAY_DELAY_SECONDS);
    });
    player.addEventListener(EVENT_TYPES.ERROR, handleCatchError);
    player.addEventListener(EVENT_TYPES.READY, player.setupBeforeRequest);

    if (isDRM) {
      player.addEventListener(EVENT_TYPES.LOADED_METADATA, player.initializeMediaKeys);
    }
  }, [isDRM, autoplay, handleCatchError]);

  return { createConfigListeners };
}

export default useConfigEvents;
